module.exports = {
  PROJECT_TITLE: 'Criador de Sites',
  NOTIFICATION_DEFAULTS: {
    timeout: 4000,
    dispensable: true
  }
}
